import React, { useState, useRef, useEffect, useCallback } from "react";
import { useSpring, animated } from "react-spring";
import { Background, ModalContent, CloseModalButton, Button } from "../../ModalRegisterStyle";
import api from "../../../../services/api";
import Swal from "sweetalert2";
import { use } from "react";

export default function Envio({ showModal, setShowModal }) {
  const modalRef = useRef();
  const animation = useSpring({
    config: {
      duration: 150,
    },
    opacity: showModal ? 1 : 0,
    transform: showModal ? `translateY(0%)` : `translateY(-100%)`,
  });
  const [pendentes, setPendentes] = useState(0);

  const keyPress = useCallback(
    (e) => {
      if (e.key === "Escape" && showModal) setShowModal(false);
    },
    [setShowModal, showModal]
  );

  const emailsPendentes = () => {
    api
      .get(`/rh/controle-cestas/emails-a-enviar/${new Date().getFullYear()}`)
      .then((response) => {
        const data = response.data || {};
        setPendentes(data.item || 0);
      })
      .catch((e) => {
        Swal.fire({
          title: "Atenção!",
          text: `${e.response?.data?.error || "Não foi possível consultar os e-mails pendentes!"}`,
          icon: "error",
        });
      });
  };

  useEffect(() => {
    document.addEventListener("keydown", keyPress);
    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);

  useEffect(() => {
    if (!showModal) return;
    emailsPendentes();
  }, [showModal]);
  const [sending, setSending] = useState(false);
  const [sentEmails, setSentEmails] = useState([]);
  const [failedEmails, setFailedEmails] = useState([]);
  const ano = new Date().getFullYear();

  const handleSend = async () => {
    try {
      setSending(true);
      setSentEmails([]);
      setFailedEmails([]);

      const response = await api.post(`/rh/controle-cestas/enviar-emails/${ano}`);

      const data = response.data || {};
      setSentEmails(data.emailsEnviados || []);
      setFailedEmails(data.emailsFalha || []);
      // console.log("1: ",data.emailsEnviados, "\n2: ",data.emailsFalha);

      Swal.fire({
        title: "Envio finalizado",
        text: `Enviados: ${data.quantidadeEmailsEnviados || (data.emailsEnviados || []).length}, falhas: ${
          data.quantidadeEmailsFalhos || (data.emailsFalha || []).length
        }`,
        icon: "success",
      });
    } catch (e) {
      Swal.fire({
        title: "Erro",
        text: e.response?.data?.error || "Erro ao enviar os emails.",
        icon: "error",
      });
    } finally {
      setSending(false);
    }
  };

  const handleClose = () => {
    setShowModal(false);
    // reset state when closing
    setSending(false);
    setSentEmails([]);
    setFailedEmails([]);
  };

  return (
    <>
      {showModal ? (
        <Background
          ref={modalRef}
          onClick={(e) => {
            if (modalRef.current === e.target) {
              handleClose();
            }
          }}
        >
          <animated.div style={animation}>
            <ModalContent style={{ maxWidth: "60vw", width: "100%" }}>
              <h3>Enviar e-mails</h3>

              <div style={{ marginTop: 12, margin: "10px" }}>
                {!sending && sentEmails.length === 0 && failedEmails.length === 0 && (
                  <>
                    <p style={{ padding: "20px 20px 0 20px" }}>
                      Ao iniciar, o sistema enviará os e-mails pendentes. {pendentes?.quantidade > 50 ? "Isso pode levar algum tempo." : ""}
                    </p>
                    <p style={{ padding: "10px 20px 20px 20px" }}>
                      Serão enviados <b>{pendentes?.quantidade} e-mails.</b>
                    </p>
                    <Button onClick={handleSend}>Enviar</Button>
                  </>
                )}

                {sending && (
                  <div style={{ padding: 20, textAlign: "center" }}>
                    <div style={{ marginBottom: 12 }}>
                      <div className="dot-spinner" style={{ margin: "0 auto" }} />
                    </div>
                    <div>Enviando e-mails... aguarde até finalizar.</div>
                  </div>
                )}

                {!sending && (sentEmails.length > 0 || failedEmails.length > 0) && (
                  <div style={{ marginTop: 16 }}>
                    <div style={{ display: "flex", gap: 16, flexDirection: "column" }}>
                      <div style={{ flex: 1, minWidth: 280 }}>
                        <h4>Enviados {sentEmails.length} emails</h4>
                        <div style={{ maxHeight: 240, overflow: "auto", border: "1px solid #eee", padding: 8 }}>
                          {sentEmails.length === 0 ? (
                            <div style={{ textAlign: "center" }}>Nenhum</div>
                          ) : (
                            <table style={{ width: "100%" }}>
                              <thead>
                                <tr>
                                  <th style={{ textAlign: "left", paddingLeft: "5px" }}>Nome</th>
                                  <th style={{ textAlign: "left", paddingLeft: "5px" }}>Matrícula</th>
                                  {/* <th style={{ textAlign: "left", paddingLeft: "5px" }}>E-mail</th> */}
                                </tr>
                              </thead>
                              <tbody>
                                {sentEmails.map((f, i) => (
                                  <tr key={i}>
                                    <td>{f.nome}</td>
                                    <td>{f.matricula}</td>
                                    {/* <td>{f.email}</td> */}
                                    {/* <td>{typeof f === "string" ? f : f.email || JSON.stringify(f)}</td> */}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          )}
                        </div>
                      </div>

                      <div style={{ flex: 1, minWidth: 280 }}>
                        <h4>Falharam {failedEmails.length} emails</h4>
                        <div style={{ maxHeight: 240, overflow: "auto", border: "1px solid #eee", padding: 8 }}>
                          {failedEmails.length === 0 ? (
                            <div style={{ textAlign: "center" }}>Nenhum</div>
                          ) : (
                            <table style={{ width: "100%" }}>
                              <thead>
                                <tr>
                                  <th style={{ textAlign: "left", paddingLeft: "5px" }}>Nome</th>
                                  <th style={{ textAlign: "left", paddingLeft: "5px" }}>Matrícula</th>
                                  {/* <th style={{ textAlign: "left", paddingLeft: "5px" }}>E-mail</th> */}
                                </tr>
                              </thead>
                              <tbody>
                                {failedEmails.map((f, i) => (
                                  <tr key={i}>
                                    <td>{f.nome}</td>
                                    <td>{f.matricula}</td>
                                    {/* <td>{f.email}</td> */}
                                    {/* <td>{typeof f === "string" ? f : f.email || JSON.stringify(f)}</td> */}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          )}
                        </div>
                      </div>
                    </div>

                    <div style={{ marginTop: 12, textAlign: "right" }}>
                      <Button onClick={handleClose}>Fechar</Button>
                    </div>
                  </div>
                )}
              </div>

              <CloseModalButton
                onClick={() => {
                  handleClose();
                }}
              />
            </ModalContent>
          </animated.div>
        </Background>
      ) : null}

      <style>{`\n        .dot-spinner {\n          width: 48px;\n          height: 12px;\n          display: inline-block;\n          position: relative;\n        }\n        .dot-spinner::before,\n        .dot-spinner::after,\n        .dot-spinner div {\n          content: '';\n        }\n        .dot-spinner::before,\n        .dot-spinner::after {\n          width: 12px;\n          height: 12px;\n          background: #1890ff;\n          border-radius: 50%;\n          display: inline-block;\n          position: absolute;\n          top: 0;\n          animation: dot 1s infinite linear;\n        }\n        .dot-spinner::before { left: 0; animation-delay: 0s }\n        .dot-spinner::after { left: 18px; animation-delay: .2s }\n        .dot-spinner div { width: 12px; height: 12px; background: #1890ff; border-radius: 50%; position: absolute; left: 36px; top: 0; animation: dot 1s infinite linear; animation-delay: .4s }\n        @keyframes dot { 0% { transform: translateY(0) } 50% { transform: translateY(-8px) } 100% { transform: translateY(0) } }\n      `}</style>
    </>
  );
}
